export default __webpack_public_path__ + "static/media/more-vertical.6f75b8c7.svg";